import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';

import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import NonFieldErrors from '@perpay-web/components/base/NonFieldErrors/NonFieldErrors';
import FormikPasswordInput from '@perpay-web/components/base/PasswordInput/FormikPasswordInput';
import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import { getClassName } from '@perpay-web/utils/domUtils';
import { passwordSchema } from '@perpay-web/validators/formBased';
import { validateForm } from '@perpay-web/validators/formBased';

import styles from './UserVerificationModal.scss';

const CreatePasswordStep = ({
    initialValues = {
        password: '',
    },
    onSubmitPassword,
    onSubmitPasswordErrors,
    onHelpButtonClick,
    loading,
    onLoadPageView,
}) => {
    const formik = useFormik({
        initialValues,
        onSubmit: (values) => {
            onSubmitPassword(values.password);
        },
        validate: (values) => validateForm(values, passwordSchema),
    });

    useEffect(() => {
        if (onLoadPageView) {
            onLoadPageView();
        }
    }, [onLoadPageView]);

    return (
        <div className={styles['modal-content']}>
            <div className={styles['step-subtitle']}>Step 1 of 2</div>
            <div className={getClassName(styles.description, styles.title)}>
                Create an account to access Perpay
            </div>
            <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit} className={styles.form}>
                    <LegacyFocusLayout
                        contentClassName={styles['form-focus-layout']}
                        footerClassName={styles['modal-footer']}
                        footer={
                            <>
                                <CustomButton
                                    type='submit'
                                    loading={loading}
                                    className={styles.button}
                                >
                                    Next
                                </CustomButton>
                                <CustomButton
                                    action='link'
                                    type='button'
                                    className={styles['button-link']}
                                    onClick={onHelpButtonClick}
                                >
                                    Get help
                                </CustomButton>
                            </>
                        }
                    >
                        <FormikPasswordInput
                            errors={onSubmitPasswordErrors}
                            name='password'
                            showPasswordIndicator
                        />
                        <NonFieldErrors
                            errors={onSubmitPasswordErrors}
                            className={styles.error}
                        />
                    </LegacyFocusLayout>
                </form>
            </FormikProvider>
        </div>
    );
};

export default CreatePasswordStep;
